<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-wind`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 12c0-3.314-3.07-6-6.857-6h-3.429c-.63 0-1.143.448-1.143 1v2c0 .552.512 1 1.143 1h3.429c1.262 0 2.286.895 2.286 2s-1.024 2-2.286 2h-16C2.512 14 2 14.448 2 15v2c0 .552.512 1 1.143 1h16C22.93 18 26 15.314 26 12zm14 2a6 6 0 010 12H3a1 1 0 01-1-1v-2a1 1 0 011-1h37a2 2 0 100-4h-3a1 1 0 01-1-1v-2a1 1 0 011-1h3zM2.903 30h21.678C27.574 30 30 32.686 30 36c0 3.237-2.315 5.875-5.212 5.996l-.207.004h-2.71c-.463 0-.845-.386-.897-.883L20.968 41v-2c0-.513.348-.935.798-.993L21.87 38h2.71c.997 0 1.806-.895 1.806-2 0-1.052-.733-1.914-1.665-1.994L24.58 34H2.903c-.463 0-.845-.386-.897-.883L2 33v-2c0-.513.349-.936.798-.993L2.903 30z"/></svg>
</template>
<script>

export default {
  name: 'IconWind',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
